var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gdi-container"},[_c('p',{staticClass:"text-2xl mb-6"},[_vm._v("Republishing Discover Stats")]),_c('filters'),_c('global-stats-card'),_c('republishing-discover-stats-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }